module.exports = __webpack_public_path__ + "img/pic_feature_03.b4e52309.jpg";